import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";

import Str from "shared/components/Str";
import OkInput from "shared/components/oknf/OkInput";
import { submitOnEnterKeyDown } from "apps/phone_verification/util/helpers";

const IntroScreen = ({ phoneNumber, setPhoneNumber, onNext }) => {
	const inputRef = useRef(null);
	useEffect(() => {
		inputRef.current.focus();
	}, []);

	return (
		<div className="phone-verification-intro-screen">
			<h3 className="phone-verification-title">
				<Str>Move to SMS</Str>
			</h3>
			<p className="phone-verification-subtitle">
				<Str>Keep the conversation going on your SMS client, without exchanging contact info.</Str>
			</p>
			<OkInput
				ref={inputRef}
				className="phone-verification-input has-prefix"
				value={phoneNumber}
				onChange={(event) => setPhoneNumber(event.target.value)}
				onKeyDown={(event) => submitOnEnterKeyDown({
					event,
					onSubmit: onNext,
					disabled: phoneNumber.length < 10,
				})}
				pattern="\d+"
				maxLength={10}
			>
				<span className="input-prefix">
					+1
				</span>
			</OkInput>
			<p className="phone-verification-legal">
				<Str>
					You’ll only have to verify your number once. Standard message and data rates may apply.
				</Str>
			</p>
			<button className="phone-verification-next-button" onClick={onNext} disabled={phoneNumber.length < 10}>
				<Str>Next</Str>
			</button>
		</div>
	);
};

IntroScreen.propTypes = {
	phoneNumber: PropTypes.string.isRequired,
	setPhoneNumber: PropTypes.func.isRequired,
	onNext: PropTypes.func.isRequired,
};

export default IntroScreen;



// WEBPACK FOOTER //
// ./src/apps/phone_verification/components/IntroScreen.jsx